import { SPACING } from '@alto/design-library-tokens';
import { ActionSheetV2, Body, LgPadding } from '@alto/design-system';
import React from 'react';

export const TriggerDateInfoActionSheet = () => (
  <ActionSheetV2 title="Why we ask for your trigger date">
    <LgPadding topPadding={SPACING.STATIC.NONE}>
      <Body>
        You won't need these medications after your trigger date, so knowing when this will occur helps us determine the
        amount of medication to send and when to send it — per your Progyny coverage.
      </Body>
    </LgPadding>
  </ActionSheetV2>
);
